import { Box, Divider, SwipeableDrawer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ChangeColor from "./ChangeColor";
import ChangeThemeIcon from "./ChangeThemeIcon";

type Anchor = "top" | "left" | "bottom" | "right";

interface ThemeDrawerProps {
	anchor: Anchor;
	isOpen: boolean;
	setOpen: (open: boolean) => void;
}

export default function ThemeDrawer({
	anchor,
	isOpen,
	setOpen,
}: ThemeDrawerProps) {
	const { t } = useTranslation();

	return (
		<SwipeableDrawer
			anchor={anchor}
			open={isOpen}
			onOpen={() => {}}
			onClose={() => {
				setOpen(false);
			}}
		>
			<Box padding={2}>
				<Typography sx={{ fontWeight: "bold" }}>
					{t ? t("settings") : "Settings"}
				</Typography>
				<Divider />
				<Box display='flex' alignItems='center' columnGap={2}>
					<Typography sx={{ fontWeight: "bold" }} variant='caption'>
						{t ? t("mode") : "Mode"}
					</Typography>
					<ChangeThemeIcon />
				</Box>
				<Box display='flex' alignItems='center' columnGap={2}>
					<Typography sx={{ fontWeight: "bold" }} variant='caption'>
						{t ? t("color") : "Color"}
					</Typography>
					<ChangeColor />
				</Box>
			</Box>
		</SwipeableDrawer>
	);
}
